import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});


export const fetchCategories = createAsyncThunk<
  any,
  void, 
  { rejectValue: string }
>('categories/fetchCategories', async (_, { rejectWithValue }) => {
  try {
    const response = await API.get('/category'); 
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch categories');
  }
});

// Add Category
export const addCategory = createAsyncThunk<
  any,
  { name: string, url: string },
  { rejectValue: string }
>('categories/addCategory', async ({ name, url }, { rejectWithValue }) => {
  try {
    const response = await API.post('/category/add', { name, url });
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to add category');
  }
});

// Edit Category
export const editCategory = createAsyncThunk<
  any,
  { id: string, name: string, url: string },
  { rejectValue: string }
>('categories/editCategory', async ({ id, name, url }, { rejectWithValue }) => {
  try {
    const response = await API.put(`/category/edit/${id}`, { name, url });
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to edit category');
  }
});

// Delete Category
export const deleteCategory = createAsyncThunk<
  string,
  { id: string },
  { rejectValue: string }
>('categories/deleteCategory', async ({ id }, { rejectWithValue }) => {
  try {
    const response = await API.delete(`/category/delete/${id}`);
    return id;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to delete category');
  }
});
